<div>
  <app-members-adhered-filters *ngIf="years"
    [years]="years"
    (search)="searchData($event)">
  </app-members-adhered-filters>
  <mat-divider></mat-divider>
  <app-members-adhered-bar-chart *ngIf="data"
    [title]="text"
    [subtitle]="subtitle"
    [data]="data">
  </app-members-adhered-bar-chart>
</div>
